import CarouselAutoSlide from "../../../../assets/js/carouselAutoSlide";

export default function Guides() {
  const guidesCarouselItems = document.querySelectorAll(
    ".guides_carousel .guides_carousel-item"
  );
  const numberOfSlides = document.querySelectorAll(
    ".guides_carousel-item"
  ).length;
  const guidesPrev = document.querySelector(".carousel-control-prev");
  const guidesNext = document.querySelector(".carousel-control-next");
  const guidesCarouselWrapper = document.getElementsByClassName('guides_carousel-wrapper');
  
  if (
    numberOfSlides != null &&
    numberOfSlides <= 3
  ) {
    guidesPrev && guidesPrev.classList.add("d-lg-none");
    guidesNext && guidesNext.classList.add("d-lg-none");

    CarouselAutoSlide("#carouselGuides");
  }
  if (guidesCarouselItems != null && !(numberOfSlides <= 2)) {
    guidesCarouselItems.forEach((el) => {
      const minPerSlide = 3;
      let next = el.nextElementSibling;
      for (let i = 1; i < minPerSlide; i++) {
        if (!next) {
          next = guidesCarouselItems[0];
        }
        let cloneChild = next.cloneNode(true);
        el.appendChild(cloneChild.children[0]);
        next = next.nextElementSibling;
      }
    });
  }
  if (guidesCarouselItems != null && numberOfSlides == 2) {
    guidesCarouselItems.forEach((el) => {
      const minPerSlide = 2;
      let next = el.nextElementSibling;
      for (let i = 1; i < minPerSlide; i++) {
        if (!next) {
          next = guidesCarouselItems[0];
        }
        let cloneChild = next.cloneNode(true);
        el.appendChild(cloneChild.children[0]);
        next = next.nextElementSibling;
      }
    });
  }

  if(guidesCarouselWrapper.length > 0) {
    guidesCarouselWrapper[0].style.visibility = "visible";
  }
}
